enum FormStageName {
  accessionData,
  collectionData,
  plantMaterialData,
  addPlantMaterialData,
}

export default FormStageName;
